import {
  Box,
  Center,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { HiOutlinePencil } from "react-icons/hi";
import { RiEyeLine, RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { DeleteCourseModal } from "../../../components/admin/course/DeleteCourseModal";
import Loading from "../../../components/common/Loading";
import delete_vector from '../../../img/deleteVectorRed.svg';
import engineering from "../../../img/engring.png";
import { ICourse, Trainer } from "../../../models/course.model";
import registrationService from "../../../services/registration.service";
import Adminroutes from "../routes";
  
  const DraftCourses = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    // const [courseAvailable, setAvailable] = useState(false);
    const [loading, setLoading] = useState(true);
    // const [advertise, setAdvertise] = useState(false);
    // const [assigncourse, setAssignCourse] = useState(false);
    const [deletecourse, setDeleteCourse] = useState(false);
    const [reload, setReload] = useState(false);
    const [courseId, setCourseId] = useState("");
    const [courses, setCourses] = useState<ICourse[]>([]);
    const [trainers, setTrainers] = useState<Trainer[]>([]);
    const [trainerIds, setTrainerIds] = useState<string[]>();
    const [isSearchEmpty, setIsSearchEmpty] = useState(false);
    const [fileteredCourses, setFilteredCourses] = useState<ICourse[]>([]);
  
    const navigate = useNavigate();
    const viewCourse= async (course_id: string) => {
      navigate(Adminroutes.ACourseLink(course_id));
    };   
    useEffect(() => {
      registrationService
        .getAllCourses()
        .then((response) => {
          const courses: ICourse[] = response;
          setCourses(courses.filter((course) => course.status === 0))
          setFilteredCourses(courses.filter((course) => course.status === 0));
          setTrainers(response.trainers);
          setLoading(false);
        })
        .catch((err) => err);
    }, [reload]);
  
    
    const openDeleteCourseModal = async (id:string) =>{
      // setAvailable(false);
      // setAssignCourse(false);
      // setAdvertise(false);
      setCourseId(id);
      setDeleteCourse(true);
      onOpen();
    }
  
  
    const reloadData = () => {
      setReload(!reload);
    };
  
    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
      const searchTerm = event.target.value.toLowerCase();
      // 
      if (!searchTerm) {
        setFilteredCourses(courses);
      } else {
        if (courses) {
          const filtered = courses.filter((each: any) =>
            each.name.toLowerCase().includes(searchTerm)
          );
          setFilteredCourses(filtered);
          // 
          if (filtered && filtered.length > 0) setIsSearchEmpty(false);
          else setIsSearchEmpty(true);
        }
      }
    };
  
    return (
      <>
        {loading ? (
          <Loading />
        ) : (
          <Box>
            <Flex             minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}>
                      <Box
              width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>
  
              <Box width="100%">
                <AdminDashboardHeader />
                <Box                 pt="30px"
                px={["20px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden">
                  <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    py="26px"
                  >
                    <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                      Drafts
                    </Box>

                  </Flex>
                  <Flex py="15px" justifyContent="">
                    <InputGroup
                      color="brand.subtitle"
                      bg="white"
                      width={["100%", "100%", "50%", "30%"]}
                    >
                      <Input
                        height="40px"
                        placeholder="Search for course"
                        onChange={(e) => handleSearchChange(e)}
                        fontSize={12}
                        size="sm"
                      />
  
                      <InputRightElement
                        pointerEvents="none"
                        children={<RiSearch2Line color="red" size="0.9rem" />}
                      />
                    </InputGroup>
                  </Flex>
                  <Box width="100%">
                    <TableContainer>
                      <Table variant="simple">
                        <Thead mb="10px">
                          <Tr
                            pb="10px"
                            borderBottom="1px solid"
                            borderColor="#D5D5D5"
                          >
                            <Th textTransform="none">
                              Courses ({courses.length})
                            </Th>
                            <Th textTransform="none">Course Code</Th>
                            <Th textTransform="none">Options</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {fileteredCourses.map((each, index) => (
                            <Tr key={index} bg="white">
                              <Td>
                                <HStack spacing="10px">
                                  <Box height="55px" width="105px">
                                    <Image
                                      height="55px" 
                                      width="105px"
                                      src={
                                        each.cover_image
                                          ? each.cover_image
                                          : engineering
                                      }
                                    />
                                  </Box>
                                  <Text
                                    fontWeight="600"
                                    textTransform="lowercase"
                                    fontSize="16px"
                                    color="#616161"
                                  >
                                    {each.name.substring(0, 30)}...
                                  </Text>
                                </HStack>
                              </Td>
                              <Td>{each.code}</Td>
                              <Td>
                                <HStack>
                                  <Center
                                    border="1px solid"
                                    borderRadius="10px"
                                    borderColor="#E5E5E5"
                                    width="30px"
                                    cursor={"pointer"}
                                    onClick={() => viewCourse(each.uuid)}
                                    height="30px"
                                  >
                                    <RiEyeLine />
                                  </Center>
                                  <Center
                                    border="1px solid"
                                    borderRadius="10px"
                                    onClick={() => {
                                      navigate(Adminroutes.EditCourseLink(each.uuid));
                                    }}
                                    cursor={"pointer"}
                                    borderColor="#E5E5E5"
                                    width="30px"
                                    height="30px"
                                  >
                                    <HiOutlinePencil />
                                  </Center>
                                  <Center
                                    border="1px solid"
                                    borderRadius="10px"
                                    onClick={() => {
                                      openDeleteCourseModal(each.uuid);
                                    }}
                                    cursor={"pointer"}
                                    borderColor="#E5E5E5"
                                    width="30px"
                                    height="30px"
                                  >
                                    <Image src={delete_vector} width="18px" height="18px"/>
                                  </Center>
                                </HStack>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              </Box>
            </Flex>
  
            {deletecourse && (
              <Portal >
                {" "}
                <DeleteCourseModal
                  isOpenDelete={isOpen}
                  onCloseDelete={onClose}
                  courseId={courseId}
                  updateRecord={reloadData}
                />{" "}
              </Portal>
            )}
  
          </Box>
        )}
      </>
    );
  };
  
  export default DraftCourses;